module.exports = function anonymous(data
/**/) {
var out='<div class="first"></div><div class="second"></div>';return out;
}